import { instagramPermissions } from '../../../../../../Model/InstagramUser';

export default {
  title: 'Instagram Configuration',
  description: 'Connect your Instagram for better insights on your posts and stories.',
  connectInstagramAccount: 'Connect Instagram Account',
  outreachTitle: 'Instagram Outreach',
  outreachDescription: 'Connect your Instagram to allow us to reach out to leads and address their concerns.',
  connectDifferentAccount: 'Connect a Different Account',
  orUsePrimaryForOutreach: 'Or use @{handle} for outreach',
  useSameAccount: 'Use Same Account',
  useSameAccountDisabledTooltip: 'You need to grant message permissions to use the same account',
  usingSameAccount: 'Using same account as above',
  instagramAccountConnected: 'Connected as {handle}',
  grantedPermissions: 'Granted Permissions',
  permissions: {
    [instagramPermissions.INSTAGRAM_BUSINESS_BASIC]: {
      title: 'Basic Instagram Business Information',
    },
    [instagramPermissions.INSTAGRAM_BUSINESS_MANAGE_MESSAGES]: {
      title: 'Manage Instagram Messages',
    },
  },
  grantMessagePermission: 'Grant Message Permission',
  missingMessagePermissionsWarning: 'Instagram outreach won\'t work until you grant message permissions.',
};
